module.exports = __webpack_public_path__ + "static/media/HCMM651.9ed79e32.jpg";